import { GIGYA_LOGIN } from "constants/storage";
import { getFromLocalStorage } from "core/utils/utils.helper";
import { useState, useEffect } from "react";

// Define the return type
interface AuthState {
  isAuthenticated: boolean;
}

const useAuth = (): AuthState => {
  // State with explicit type
  const [authState, setAuthState] = useState<AuthState>(() => {
    // Initial check for "uid-login" in localStorage
    return {
      isAuthenticated: !!getFromLocalStorage(GIGYA_LOGIN.KEY),
    };
  });

  useEffect(() => {
    // Function to check authentication status
    const checkAuth = () => {
      const hasUid = !!getFromLocalStorage(GIGYA_LOGIN.KEY);
      setAuthState({ isAuthenticated: hasUid });
    };

    // Listen for storage events to detect changes from other tabs
    window.addEventListener("storage", checkAuth);

    // Create a custom event listener for same-tab updates
    const handleStorageChange = () => checkAuth();
    window.addEventListener(GIGYA_LOGIN.EVENT, handleStorageChange);

    // Cleanup event listeners
    return () => {
      window.removeEventListener("storage", checkAuth);
      window.removeEventListener(GIGYA_LOGIN.EVENT, handleStorageChange);
    };
  }, []); // Empty dependency array since we only want this to run once on mount

  return authState;
};

export default useAuth;
